var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-notes"},[_c('item-title',{attrs:{"title":"兑换须知","bottom":"0.36rem"}}),_c('van-row',{staticClass:"c-main"},[_c('div',{staticClass:"c-m-content",domProps:{"innerHTML":_vm._s(_vm.exchangeNotice)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }